export default __webpack_public_path__ + "static/media/zodiac10.9882e760.png";